import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';
import { PlansService } from 'src/app/services/plans.service';
import { VendorService } from 'src/app/services/vendor.service';
import { UtilsService } from 'src/app/utils.service';


@Component({
  selector: 'app-header-latest',
  standalone: true,
  imports: [CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './header-latest.component.html',
  styleUrl: './header-latest.component.scss'
})
export class HeaderLatestComponent {
  [key: string]: any;

  isLoggedIn = false;
  freePlan: any;
  activePath: string = '';

  private loginStatusSubscription: Subscription;
  data: any = {}
  constructor(
    private router: Router,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private vendorService: VendorService,
    private plansService: PlansService,
    private adminService: AdminService,
    private utilsService: UtilsService,


  ) {
    this.getPlans()
  }

  /* ngOnInit(){
    this.loginStatusSubscription = this.authService.getLoginStatus().subscribe(status => {
    this.isLoggedIn = status;
    this.cdRef.detectChanges(); // Trigger change detection
    console.log("isLoggedIn === ", this.isLoggedIn)
    });
  } */
  ngOnInit() {
    this.activePath = this.router.url; // set initial path

    this.loginStatusSubscription = this.authService.getLoginStatus().subscribe(status => {
    this.isLoggedIn = status;
    this.cdRef.detectChanges();
    console.log("isLoggedIn === ", this.isLoggedIn);
    });

    // Listen for route changes
   this.router.events
  .pipe(filter(event => event instanceof NavigationEnd))
  .subscribe((event: NavigationEnd) => {
    this.activePath = event.urlAfterRedirects;
  });

    this.utilsService.profileActionData.subscribe((data: any) => {
      if (data?.profileData) {
        this.data = data.profileData;
      }
    });
  }
  logout(): void {
    this.authService.logout();
    this.vendorService.clearData();
    this.router.navigate(['/']); // Redirect to login page or home page after logout
  }

  goTo(link: any) {
    this.router.navigate([link])
  }

  goToFreePlan(plan: any) {
    this.plansService.selectedPlan = plan; // Store the selected plan object
    this.router.navigate(['/product-details']);
    console.log("plan check", plan)
  }

  getPlans() {
    let reqObj = {};
    this.adminService.getPlans(reqObj).subscribe((response) => {
    if (response.statusCode === 200) {
        const jobsPlans = response.data.plans.JOBS;
        console.log("JOBS Plans:", jobsPlans);
        this.freePlan = jobsPlans.find(plan => plan.plan_type === 'F');
        console.log("CCCCC", this.freePlan)
      }
    });
  }


  goToDashboard() {
  const role = this.data.role;

  console.log("role", role);

  switch (role) {
    case 'VENDOR':
    this.router.navigate(['vendor/hrms-dashboard']);
      break;

    case 'VENDOR_EMP':
    this.router.navigate(['/vendor/employee/console']);
      break;

    case 'AGENT':
    this.router.navigate(['/admin/agents-console']);
      break;

    case 'INTERVIEWER':
    this.router.navigate(['/interviewer']);
      break;

    case 'USER':
    this.router.navigate(['job-seeker/new-dashboard']);
      break;

    default:
    console.warn('Unknown role:', role);
      break;
  }
}

goToFeatures() {
  const targetRoute = '/products'; 

  const currentBase = this.router.url.split('#')[0].split('?')[0];

  if (currentBase === targetRoute) {
    this.scrollToCompareFeatures();
  } else {
    this.router.navigate([targetRoute]).then(() => {
      this.scrollToCompareFeatures();
    });
  }
}

private scrollToCompareFeatures(retries: number = 20) {
  const el = document.getElementById('compareFeatures');

  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else if (retries > 0) {
    setTimeout(() => this.scrollToCompareFeatures(retries - 1), 150);
  }
}

}